import { getImageBlockSizes as getImageBlockSizesVolto } from '@plone/volto/components/manage/Blocks/Image/utils';

export const isRERPortal = () => {
  let test =
    process.env.RAZZLE_IS_RER_PORTAL ||
    (__CLIENT__ && window?.env.RAZZLE_IS_RER_PORTAL);

  test = test == true || test === 'true';
  return test;
};

export const getImageBlockSizes = ({
  align = 'center',
  size = 'l',
  ...rest
}) => {
  //set default values for getImageBlockSizes from volto
  return getImageBlockSizesVolto({ align, size, ...rest });
};
